/** moment.js RU date format */
export const RU_DATE_FORMAT = 'DD.MM.YYYY';

/** moment.js ISO date format */
export const ISO_DATE_FORMAT = 'YYYY-MM-DD';

/** moment.js human-readable datetime format */
export const DATETIME_HR_FORMAT = 'YYYY-MM-DD HH:mm:ss';
